import { render, staticRenderFns } from "./studentAvatar.vue?vue&type=template&id=61afdec8&scoped=true"
import script from "./studentAvatar.vue?vue&type=script&lang=js"
export * from "./studentAvatar.vue?vue&type=script&lang=js"
import style0 from "./studentAvatar.vue?vue&type=style&index=0&id=61afdec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61afdec8",
  null
  
)

export default component.exports